module.exports = __webpack_public_path__ + "img/csr_032423_A.2ea71c60.jpg";